import { ExtraService } from "model/insurance-product.interface";

export function keyRandomUnique(): number {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
}

export function getServiceExtra(addonsIncluded: any[], categoryId: any): ExtraService[] {

       let arr: any[] = [];

    if(addonsIncluded && addonsIncluded.length) {
      addonsIncluded.forEach((addon: any) => {

        switch(categoryId) {
          case 1:
                arr.push({name: addon.title, price: addon.netcost.amount});
          break;
        }

      });
    }

    return arr;
}

// Función helper para limpiar strings
export function cleanString(value: any): string | null {
  if (value === null || value === undefined) return null;
  const str = String(value);
  return str.trim() || null;
}

// Función para limpiar número (opcional)
export function cleanNumber(value: any): number | null {
  if (value === null || value === undefined) return null;
  const num = Number(value);
  return isNaN(num) ? null : num;
}

// Función para normalizar texto (quitar acentos, convertir a minúsculas)
export function normalizeText(text: string): string {
  if (!text) return '';

  return text
    .toLowerCase()
    .normalize('NFD') // Descompone caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
    .trim();
}

